<template>
  <v-card class="mt-0" flat>
    <template v-for="(d, name, index) in departments">
      <h4 :key="index">{{ name }}</h4>

      <!-- <v-expand-transition :key="index" v-if="searched && searched.length > 0"> -->
      <v-expand-transition :key="index" v-if="d && d.length > 0">
        <v-expansion-panels class="mt-0">
          <v-expansion-panel v-for="ap in d" :key="ap.id">
            <v-expansion-panel-header expand-icon="$sl-arrow-down" two-line>
              <div>
                <div class="header-title text-capitalize" v-if="ap && ap.person">
                  {{ ap.person | fullName }}
                </div>
                <div class="subtitle-2 gray">
                  {{ ap.startDate | date }} — {{ ap.endDate | date }}
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <h6 class="subtitle-2">{{ $t("company.exemption-issued") }}</h6>
              <p class="caption" v-if="ap.approvedBy">
                {{ ap.approvedBy.firstName || "" }} {{ ap.approvedBy.lastName || "" }}
              </p>
              <h6 class="subtitle-2">{{ $t("company.exemption-start-date") }}</h6>
              <p class="caption">{{ ap.approvedAtSecondary | date }}</p>
              <h6 class="subtitle-2">{{ $t("company.startFrom") }}</h6>
              <p class="caption">{{ ap.startDate | date }}</p>
              <h6 class="subtitle-2">{{ $t("company.until") }}</h6>
              <p class="caption">{{ ap.endDate | date }}</p>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-expand-transition>
    </template>

    <p class="overline small">{{ $t("company.legend") }}</p>

    <div class="caption mt-n2">
      {{ $t("company.desc-instructor") }}
    </div>
    <div class="caption mt-1">
      {{ $t("company.desc-yua") }}
    </div>
    <div class="caption mt-1">
      {{ $t("company.desc-apprentice") }}
    </div>
    <div class="caption mt-1">
      {{ $t("company.desc-wp") }}
    </div>
  </v-card>
</template>

<script>
import API from "@/services/api.js";
import ActionButton from "@/components/Common/ActionButton";
import filter from "lodash/filter";
import find from "lodash/find";
import groupBy from "lodash/groupBy";
import assign from "lodash/assign";

const SugarDate = require("sugar/date");

export default {
  name: "CompanyPausedPersonDetail",

  props: {
    searched: {
      type: Array,
      default: [],
    },
  },
  components: {
    ActionButton,
  },
  created() {
    this.init();
  },
  data() {
    return {
      departments: [],
      noDepartment: [],
    };
  },
  computed: {},

  methods: {
    init() {      
      let empDep = [];
      let noDep = [];

      this.searched.forEach((se) => {
        se.book.person.apprenticeships.forEach((appr) => {
          if (appr.workplaces && appr.workplaces.length > 0) {
            appr.workplaces.forEach((wp) => {
              if (wp.workplaceaddress.companyId == this.$route.params.id) {
                wp.workplaceaddress.departmentWorkplaces.forEach((dp) => {
                  empDep.push({
                    id: dp.id,
                    depName: dp.department.name,
                    person: se.book.person,
                    endDate: se.endDate,
                    startDate: se.startDate,
                  });
                });
              }
            });
          } else {
            empDep.push({
              id: appr.id,
              depName: this.$t("company.missing-department"),
              person: se.book.person,
              endDate: se.endDate,
              startDate: se.startDate,
            });
          }
        });
        this.noDepartment = groupBy(noDep, function (o) {
          return o.depName;
        });
        this.departments = groupBy(empDep, function (o) {
          return o.depName;
        });
        this.departments = assign(this.departments, this.noDepartment);        
      });
      this.noDepartment = groupBy(noDep, function (o) {
        return o.depName;
      });
      this.departments = groupBy(empDep, function (o) {
        return o.depName;
      });
      this.departments = assign(this.departments, this.noDepartment);
    },
  },
};
</script>
<style scoped></style>
